import { FieldArray } from "formik";
import { registerWidget } from "./registry";
import { renderFieldAsRow } from "./renderer";

export const FormArrayField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  if (formikParams.readOnly != null)
    extraProps["readOnly"] = formikParams.readOnly;
  const { values = {} } = formikParams;
  return (
    <FieldArray
      key={config.key ?? config.name}
      name={config.name}
      render={arrayHelpers => (
        <div>
          {values[config.name] && values[config.name].length > 0 ? (
            values[config.name].map((_: any, index: number) => (
              <div className="row" key={index}>
                <div className="col-lg-8" style={{ width: "86%", position: "relative" }}>
                  <div className="row">
                    {
                      config.children?.map((x: any) => (
                        <div key={x.name} style={{ padding: "10px" }} className={x.gridClassName ?? "col-lg-6"}>{renderFieldAsRow(formikParams)({ ...x, name: `${config.name}.${index}.${x.name}` })}</div>
                      ))
                    }
                  </div>
                </div>
                <div style={{ float: "left", width: "14%" }}>
                  <div>
                    <button
                      type="button"
                      className="btn btn-danger"
                      style={{ margin: "10px" }}
                      disabled={values[config.name].length == 1}
                      onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                    >
                      <span className="material-icons" title="Supprimer la ligne">delete</span>
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ margin: "10px" }}
                      onClick={() => arrayHelpers.insert(index, {})} // insert an empty string at a position
                    >
                      <span className="material-icons" title="Ajouter">add</span>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <button type="button" onClick={() => arrayHelpers.push({})}>
              {/* show this when user has removed all friends from the list */}
              <span className="material-icons" title="Ajouter">add</span>
            </button>
          )
          }
        </div >
      )}
    />
  );
};

registerWidget("array", FormArrayField);
